import { render, staticRenderFns } from "./bk0.vue?vue&type=template&id=648f7c22"
import script from "./bk0.vue?vue&type=script&lang=js"
export * from "./bk0.vue?vue&type=script&lang=js"
import style0 from "./bk0.vue?vue&type=style&index=0&id=648f7c22&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports